import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import PageTitle from '../components/pageTitle';
import './passwordReset.css';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const submit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setError('');
        try {
            await api.post('/user/forgot-password', { email: email.trim().toLowerCase() });
            setSubmitted(true);
        } catch (requestError) {
            setError('Unable to submit the request right now. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <PageTitle title="Forgot password" />
            <main className="auth-shell password-reset-page">
                <section className="auth-card">
                    <header className="auth-header">
                        <h3>Reset your password</h3>
                        <p>Enter the email address associated with your account.</p>
                    </header>
                    {submitted ? (
                        <div className="password-reset-result" role="status">
                            <p>If an account exists for that email, a password reset link will be sent shortly.</p>
                            <Link to="/login" className="auth-inline-link">Back to log in</Link>
                        </div>
                    ) : (
                        <form className="auth-form" onSubmit={submit}>
                            <div className="user-input-area auth-fields">
                                <label className="auth-label" htmlFor="reset-request-email">Email</label>
                                <input
                                    id="reset-request-email"
                                    className="text-input-generic primary-font password-reset-input"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    maxLength={254}
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                />
                            </div>
                            {error && <p className="password-reset-error" role="alert">{error}</p>}
                            <div className="auth-actions auth-actions-spread password-reset-actions">
                                <Link to="/login" className="auth-inline-link">Back to log in</Link>
                                <button className="button-primary primary-bg primary-font" type="submit" disabled={submitting}>
                                    {submitting ? 'Sending...' : 'Send reset link'}
                                </button>
                            </div>
                        </form>
                    )}
                </section>
            </main>
        </>
    );
};

export default ForgotPasswordPage;